import { Middleware, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { clearCache } from "Data/Actions/System";
import { logoutUserAction } from "Data/Redux/Slices/User";
import { pusherConnection } from "src/Pusher";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const disconnectOnLogout: Middleware = (store) => (next) => (action) => {
	const assertedAction = action as PayloadAction<number>;

	if (assertedAction.type === "LOGOUT_USER/pending") {
		pusherConnection.disconnect();
	}

	return next(action);
};

export const logoutOnUnauthorized: Middleware = store => next => action => {
	const assertedAction = action as PayloadAction<unknown, string, object, SerializedError>;

	if (assertedAction.type?.includes("rejected") && assertedAction.error.message === "401") {
		store.dispatch(logoutUserAction());
		store.dispatch(clearCache());
	}

	return next(action);
};
